export default {
  // 查询喷灌计划列表
  selectJgIrrigationPlanByPage: '/business/jgIrrigationPlan/selectJgIrrigationPlanByPage',
  // 启用/禁用喷灌计划
  updateJgIrrigationPlanStatus: '/business/jgIrrigationPlan/updateJgIrrigationPlanStatus',
  // 查询喷灌区域详情
  selectJgIrrigationAreaByAreaId: '/business/jgIrrigationArea/selectJgIrrigationAreaByAreaId',
  // 喷灌电磁阀打点和修改名称
  updateJgIrrigationValveLocation: '/business/jgIrrigationDevice/updateJgIrrigationValveLocation',
  // 手动开启电磁阀
  insertJgIrrigationValveRecord: '/business/jgIrrigationDevice/insertJgIrrigationValveRecord',
  // 查询电磁阀设备列表
  selectJgIrrigationValveByList: '/business/jgIrrigationDevice/selectJgIrrigationValveByList',
  selectJgIrrigationValve: '/business/jgIrrigationDevice/selectJgIrrigationValve',
  // 查询土壤设备列表
  selectJgIrrigationSoilByList: '/business/jgIrrigationDevice/selectJgIrrigationSoilByList',
  // 查询水表设备列表
  selectJgIrrigationWaterByList: '/business/jgIrrigationDevice/selectJgIrrigationWaterByList',
  // 查询电表设备列表
  selectJgIrrigationElectricityByList: '/business/jgIrrigationDevice/selectJgIrrigationElectricityByList',
  selectSoilDataByPage: '/business/jgSoilInfo/selectJgSoilDataByPage',
  // 查询土壤设备详情
  selectSoilInfoByDeviceNumber: '/business/jgSoilInfo/selectSoilInfoByDeviceNumber',

  updateIrrigationValveLocation: '/business/irrigationDevice/updateIrrigationValveLocation',
  insertIrrigationValveRecord: '/business/jgIrrigationDevice/insertJgIrrigationValveRecord',
  selectIrrigationValveByList: '/business/irrigationDevice/selectIrrigationValveByList',
  selectIrrigationValveByPage: '/business/irrigationDevice/selectIrrigationValveByPage',
  selectIrrigationWaterByList: '/business/irrigationDevice/selectIrrigationWaterByList',
  selectIrrigationSoilByList: '/business/irrigationDevice/selectIrrigationSoilByList',
  selectIrrigationElectricityByList: '/business/irrigationDevice/selectIrrigationElectricityByList',
  selectIrrigationValveRecordByPage: '/business/jgIrrigationDevice/selectJgIrrigationValveRecordByPage',
  insertIrrigationArea: '/business/jgIrrigationArea/insertJgIrrigationArea',
  updateIrrigationArea: '/business/jgIrrigationArea/updateJgIrrigationArea',
  deleteIrrigationArea: '/business/irrigationArea/deleteIrrigationArea',
  selectIrrigationAreaByAreaId: '/business/jgIrrigationArea/selectJgIrrigationAreaByAreaId',
  selectIrrigationAreaByPage: '/business/jgIrrigationArea/selectJgIrrigationAreaByPage',
  selectIrrigationAreaIndex: '/business/irrigationArea/selectIrrigationAreaIndex',
  insertIrrigationPlan: '/business/jgIrrigationPlan/insertJgIrrigationPlan',
  updateIrrigationPlan: '/business/jgIrrigationPlan/updateJgIrrigationPlan',
  deleteIrrigationPlan: '/business/jgIrrigationPlan/deleteJgIrrigationPlan',
  updateIrrigationPlanStatus: '/business/jgIrrigationPlan/updateJgIrrigationPlanStatus',
  selectIrrigationPlanByPlanId: '/business/jgIrrigationPlan/selectJgIrrigationPlanByPlanId',
  selectIrrigationPlanByPage: '/business/jgIrrigationPlan/selectJgIrrigationPlanByPage',
  selectIrrigationPlanRecordByPage: '/business/jgIrrigationPlan/selectJgIrrigationPlanRecordByPage',
  selectIrrigationProjectWebList: '/business/jgIrrigationArea/selectJgIrrigationProjectWebList',
  selectJgIrrigationWaterLyByList: '/business/jgIrrigationDevice/selectJgIrrigationWaterLyByList'
}
